<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card card-vampire">
          <div class="card-header">
            <h5 class="card-title mb-0">Recuperar Senha</h5>
          </div>
          <div class="card-body">
            <form @submit.prevent="requestPasswordReset">
              <div class="mb-3">
                <label for="email" class="form-label">Email</label>
                <input type="email" class="form-control" id="email" v-model="email" required>
              </div>
              <div v-if="message" class="alert alert-info">{{ message }}</div>
              <div v-if="error" class="alert alert-danger">{{ error }}</div>
              <div class="d-grid">
                <button type="submit" class="btn btn-vampire" :disabled="isLoading">
                  <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Enviar Link de Recuperação
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api';

export default {
  data() {
    return {
      email: '',
      message: '',
      error: '',
      isLoading: false,
    };
  },
  methods: {
    async requestPasswordReset() {
      this.isLoading = true;
      this.message = '';
      this.error = '';

      try {
        const response = await api.post('/auth/forgot-password', { email: this.email });
        this.message = response.data.message;
      } catch (err) {
        this.error = err.response?.data?.error || 'Ocorreu um erro ao processar sua solicitação.';
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.card-vampire {
  background-color: var(--vampire-dark-gray);
  border: 1px solid var(--vampire-red);
  color: var(--vampire-light-text);
}
</style>
